import React, { useContext } from 'react';

import CenterImage from './../CenterImage/CenterImage';

import Store from '../../store';

import GdprGerSvg from './GdprGerSvg';
import GdprEngSvg from './GdprEngSvg';

const svgStyle = { maxWidth: '120px' };

const GdprImage = () => {
  const {
    state: { language },
  } = useContext(Store);
  return language === 'de' ? (
    <CenterImage image={<GdprGerSvg styles={svgStyle} />} />
  ) : (
    <CenterImage image={<GdprEngSvg styles={svgStyle} />} />
  );
};

export default GdprImage;
